// extracted by mini-css-extract-plugin
export var creditCardImg = "comparisonTable-module--creditCardImg--3k9VX";
export var halvaImg = "comparisonTable-module--halvaImg--jAZTp";
export var img = "comparisonTable-module--img--DiRzt";
export var secondContainer = "comparisonTable-module--secondContainer--F3-Ad";
export var section = "comparisonTable-module--section--OF6Ry";
export var table = "comparisonTable-module--table--voSMO";
export var tableRow = "comparisonTable-module--tableRow--tPnbX";
export var tableRow1 = "comparisonTable-module--tableRow1--Y0C1C";
export var tableRow2 = "comparisonTable-module--tableRow2--XqJvX";
export var tableRow3 = "comparisonTable-module--tableRow3--ol8SK";
export var tableSubtitle = "comparisonTable-module--tableSubtitle--PJ7c8";
export var tableText = "comparisonTable-module--tableText--fCK0O";
export var tableTitle = "comparisonTable-module--tableTitle--Cc8e4";